import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import { getBusinessUnitDisplayName } from '../utils/String';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeBusinessUnitSelectOption = ({
  id,
  name,
  logoUrl,
  logoAltText,
  resizedUrl
}, showOptionImage) => {
  const displayName = getBusinessUnitDisplayName(name, id);
  let imageOrAvatar = {};
  if (showOptionImage) {
    imageOrAvatar = resizedUrl || logoUrl ? {
      imageUrl: resizedUrl || logoUrl,
      logoAltText
    } : {
      avatar: /*#__PURE__*/_jsx(AvatarDisplay, {
        displayName: displayName,
        type: "contact",
        size: "xs"
      })
    };
  }
  return Object.assign({
    text: displayName,
    value: id
  }, imageOrAvatar);
};